import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/shared/modal'
import ScheduleTourForm from 'forms/public/schedule-tour'

const ScheduleTour = ({
  title,
  toggle,
  setActiveModal,
  setSelected,
  spaces,
  place,
  selectedSpace,
}) => {
  return (
    <Modal title={`Schedule a tour for ${title}`} onClose={toggle}>
      <div className="modal-body my-5">
        <ScheduleTourForm
          setActiveModal={setActiveModal}
          setSelected={setSelected}
          spaces={spaces}
          place={place}
          selectedSpace={selectedSpace}
        />
      </div>
    </Modal>
  )
}

ScheduleTour.propTypes = {
  title: PropTypes.string.isRequired,
  setActiveModal: PropTypes.func.isRequired,
  setSelected: PropTypes.func.isRequired,
  selectedSpace: PropTypes.object,
  toggle: PropTypes.func,
  spaces: PropTypes.array,
  place: PropTypes.string,
}

export default ScheduleTour
